export const AGORA_APP_ID = 'fa2f34400c714532b9ea27762fb09e8b';

export const AttendanceStatus = {
  NOT_MARKED: 'NOT_MARKED',
  MARKED: 'MARKED',
  IN_PROGRESS: 'IN_PROGRESS'
};

export const ScreenTypes = {
  LOADING: 'LOADING',
  NO_SYSTEM_REQUIREMENTS: 'NO_SYSTEM_REQUIREMENTS',
  START_SCREEN: 'START_SCREEN',
  LIVE_CLASS: 'LIVE_CLASS'
};

export const AGORA_CLIENT_DEFAULTS = {
  mode: 'live',
  codec: 'h264'
};

export const roles = {
  TEACHER: 'TEACHER',
  LEARNER: 'LEARNER',
  CO_TEACHER: 'CO_TEACHER'
};

export const OnStageStatus = {
  DEFAULT: 'DEFAULT',
  ON_STAGE: 'ON_STAGE',
  INVITED: 'INVITED',
  REJECTED: 'REJECTED'
};

export const AudioStatus = {
  REQUESTED_PLAYING: 'REQUESTED_PLAYING',
  REQUESTED_MUTE: 'REQUESTED_MUTE'
};

export const LiveClassEventType = {
  RAISING_HAND: 'RAISING_HAND',
  JOINED_CLASS: 'JOINED_CLASS',
  LEFT_CLASS: 'LEFT_CLASS',
  CARD_COMPLETED: 'CARD_COMPLETED',
  ANSWERED_POLL: 'ANSWERED_POLL',
  COURSE_STARTED: 'COURSE_STARTED',
  COURSE_ENDED: 'COURSE_ENDED',
  SENT_MESSAGE: 'SENT_MESSAGE',
  ONE_MINUTE_SPENT: 'ONE_MINUTE_SPENT'
};

export const LiveClassEventTypeForReport = {
  RAISING_HAND: 'RAISING_HAND',
  ANSWERED_POLL: 'ANSWERED_POLL',
  SENT_MESSAGE: 'SENT_MESSAGE'
};

export const StageTypes = {
  TEACHER: 'TEACHER',
  TEACHER_SCREEN_SHARE: 'TEACHER_SCREEN_SHARE',
  LEARNER: 'LEARNER',
  ASSET: 'ASSET',
  WHITEBOARD: 'WHITEBOARD',
  DISCUSSION: 'DISCUSSION'
};

export const Tabs = {
  LEARNERS: 'MEMBERS',
  CHAT: 'CHAT',
  ACTIVITY: 'ACTIVITY',
  PROGRESS: 'PROGRESS'
};

export const AssetStoreConsts = {
  width: 352,
  height: 360,
  assetType: 'course'
};

export const StreamChatConsts = {
  appId: 'ydgpkfpdw9fx',
  secretKey: '7szz74jmmgtwf93bbecestf32wq5rk8s5sx5k7kgjna359pvdqffzkxt9t3nkbnt'
};

export const LiveClassStatus = {
  NOT_STARTED: 'NOT_STARTED',
  STARTING: 'STARTING',
  STARTED: 'STARTED',
  ENDING: 'ENDING',
  ENDED: 'ENDED'
};

export const LiveClassUserStatus = {
  IN_CLASS: 'IN_CLASS',
  LEFT: 'LEFT',
  FEEDBACK: 'FEEDBACK'
};

export const extraFunction = {
  COLLAPSE_TO_LIST_VIEW: 'COLLAPSE_TO_LIST_VIEW',
  MUTE_ALL: 'MUTE_ALL',
  UNMUTE_ALL: 'UNMUTE_ALL',
  DISABLE_VIDEO_FOR_ALL: 'DISABLE_VIDEO_FOR_ALL',
  FULL_SCREEN_VIDEO: 'FULL_SCREEN_VIDEO',
  REMOVE_VIDEO_FROM_STAGE: 'REMOVE_VIDEO_FROM_STAGE',
  ADD_PRIVATE_NOTE: 'ADD_PRIVATE_NOTE',
  SET_COURSE_AS_MAIN_STAGE: 'SET_COURSE_AS_MAIN_STAGE',
  REMOVE_COURSE_FROM_STAGE: 'REMOVE_COURSE_FROM_STAGE',
  REMOVE_COURSE: 'REMOVE_COURSE'
};

export const DiscussionTypes = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE'
};

export const AssetLockTypes = {
  NONE: 'NONE',
  CARD: 'CARD'
};

export const AnalyticsEventTypes = {
  LIVE_CLASS_ERROR: 'LIVE_CLASS_ERROR',
  RTC_INIT: 'LIVE_CLASS_RTC_INIT',
  CHAT_INIT_FAILED: 'LIVE_CLASS_CHAT_INIT_FAILED',
  PUBLISHING_STREAM: 'LIVE_CLASS_PUBLISHING_STREAM',
  PUBLISHING_SCREEN_SHARE: 'LIVE_CLASS_PUBLISHING_SCREEN_SHARE',
  STREAM_ADDED: 'LIVE_CLASS_STREAM_ADDED',
  STREAM_SUBSCRIBED: 'LIVE_CLASS_STREAM_SUBSCRIBED',
  STREAM_REMOVED: 'LIVE_CLASS_STREAM_REMOVED',
  TOGGLE_AUDIO: 'LIVE_CLASS_TOGGLE_AUDIO',
  TOGGLE_VIDEO: 'LIVE_CLASS_TOGGLE_VIDEO',
  STREAM_PLAY_ERROR: 'LIVE_CLASS_STREAM_PLAY_ERROR',
  PLAYER_STATUS_CHANGE: 'LIVE_CLASS_PLAYER_STATUS_CHANGE'
};

export const convertColorToRGBA = color => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
    c = color.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    // eslint-disable-next-line no-bitwise
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.6)';
  }
  return null;
};

export const DocType = {
  WHITEBOARD: 'whiteboard'
};

export const SketchActions = {
  ADDED: 'add',
  UPDATED: 'update',
  REMOVED: 'removed',
  REMOVE_ALL: 'remove_all'
};

export const WHITEBOARD_STATE_DOC_ID = 'whiteboard-state';
